import Evaporate from 'evaporate';
import SparkMD5 from 'spark-md5';
import variable from '@/config/variables';
import webcall from '@/libs/webcall';

/**
 * TODO: Need to implement uploader inside a web-worker. Currently slowing down the main thread (i.e. UI) when uploading is in progress.
 * Make the default Evaporate configuration for uploading the main video file.
 * @returns a configuration file for Evaporate.create()
 */
const makeEvaporateConfig = (uuid) => {
  const config = {
    awsSignatureVersion: 2,
    signerUrl: variable.AWS.SIGNER_URL(uuid),
    signHeaders: webcall.getHeader(),
    awsRegion: 'ap-southeast-1',
    aws_key: variable.AWS.KEY,
    bucket: variable.AWS.BUCKET,

    encodeFilename: true,
    logging: false,
    computeContentMd5: true,
    cryptoMd5Method: data => btoa(SparkMD5.ArrayBuffer.hash(data, true)),
    onlyRetryForSameFileName: true,
    s3Acceleration: true,
  };
  // NOTE: If s3Acceleration is disabled execute the 2 lines below.
  if (!config.s3Acceleration) {
    config.aws_url = variable.AWS.UPLOAD_ENDPOINT;
    config.cloudfront = true;
  }
  return config;
};

/**
 * Generate aws file key using a fileMeta object.
 * @param {*} fileMeta
 */
const makeAwsFileKey = (fileMeta) => {
  if (fileMeta.file_key) return fileMeta.file_key;
  if (fileMeta.response && fileMeta.response.fileKey) return fileMeta.response.fileKey;

  if (!fileMeta.path || !fileMeta.name) throw new Error('fileMeta.path and/or fileMeta.name is invalid');
  return fileMeta.path + fileMeta.name;
};

/**
 * Uploader - abstract the upload process.
 * Uploader currently uses evaporate to handle video uploading.
 */
export default class Uploader {
  constructor(uuid) {
    this.config = makeEvaporateConfig(uuid);
    this.evaporate = Evaporate.create(this.config)
      .then((evaporate) => {
        this.evaporate = evaporate;
      });
  }

  static makeAwsFileKey(fileMeta) {
    return makeAwsFileKey(fileMeta);
  }

  /**
   * Upload a file to AWS
   * @param {object} fileMeta
   * @param {function} progressTickCallback
   * @returns the fileKey from AWS upon the completion of uploading in format: bucketName/name
   */
  upload(fileMeta, progressTickCallback) {
    // Begin uploading process
    return this.evaporate.add({
      'name': makeAwsFileKey(fileMeta),
      'file': fileMeta.file,
      'x-amz-acl': 'public-read',
      'progress': progressTickCallback,
    });
  }

  /**
   * Cancel an on-going AWS upload
   * @param {object} fileMeta
   * @returns a promise that resolves when the upload is completely canceled or rejects if the upload could not be canceled without errors.
   */
  cancel(accessKey, name) {
    // Begin uploading process
    const awsS3ObjectKey = `${variable.AWS.BUCKET}/${accessKey}/${name}`;
    return this.evaporate.cancel([awsS3ObjectKey]);
  }

  pause(accessKey, name) {
    // Begin uploading process
    const awsS3ObjectKey = `${variable.AWS.BUCKET}/${accessKey}/${name}`;
    return this.evaporate.pause([awsS3ObjectKey]);
  }

  resume(accessKey, name) {
    // Begin uploading process
    const awsS3ObjectKey = `${variable.AWS.BUCKET}/${accessKey}/${name}`;
    return this.evaporate.resume([awsS3ObjectKey]);
  }
}




// WEBPACK FOOTER //
// ./src/libs/Uploader.js